/**
 * 4 Nov 2026 (D-1104-BOOK): "Did <first name> confirm this date?" and the second visit.
 *
 *   HK_BOOK_ASK_CONFIRM   Yes (default)  Book asks the question with two buttons and no default: "Book — confirmed by
 *                                        phone" (after the booking applies, the existing Record Tenant Confirmation
 *                                        Response: Confirmed, Phone Call) and "Book — not confirmed yet".
 *   HK_BOOK_ASK_CONFIRM   No             one Book button, the request exactly as it was.
 *   HK_BOOK_SECOND_VISIT  Yes (default)  after a first visit the sheet stays open and offers the second.
 *   HK_BOOK_SECOND_VISIT  No             Book closes after booking, as it did.
 *
 * Both are read from the Day plan settings every role already gets (/api/dayplan carries every HK_ row). No new
 * SharePoint column, list or choice value: the confirmation is the existing Queue 1 operation.
 */
export const BOOK_ASK_CONFIRM_KEY = 'HK_BOOK_ASK_CONFIRM';
export const BOOK_SECOND_VISIT_KEY = 'HK_BOOK_SECOND_VISIT';

type Settings = Record<string, string | undefined> | undefined | null;
const off = (v: unknown) => /^(no|false|off|0)$/i.test(String(v ?? '').trim());

/** On unless the row says No (a site with no row is on). */
export const bookAskConfirmOn = (s: Settings): boolean => !off(s?.[BOOK_ASK_CONFIRM_KEY]);
export const bookSecondVisitOn = (s: Settings): boolean => !off(s?.[BOOK_SECOND_VISIT_KEY]);

/** The phone yes the Book press records. The request's key is `BOOKCONF|<the create's TransactionID>` — a second press cannot send it twice. */
export const BOOKCONF_KEY_PREFIX = 'BOOKCONF|';
export const BOOKCONF_TX_PREFIX = 'TXN-BOOKCONF-';
export const BOOK_CONFIRM_NOTE = 'Confirmed by phone when booked';
export const bookConfKey = (createTxId: string): string => `${BOOKCONF_KEY_PREFIX}${createTxId}`;
export const bookConfTxId = (createTxId: string): string => `${BOOKCONF_TX_PREFIX}${createTxId.replace(/^TXN-/, '')}`;
/** Needs your attention: is this refused request a Book press's phone yes? */
export const isBookConfTx = (transactionId: string | null | undefined): boolean => String(transactionId ?? '').startsWith(BOOKCONF_TX_PREFIX);

/** The app's own record of a phone yes waiting for its booking to apply (closed with a status, never deleted). */
export const BOOK_CONFIRM_AFTER_FOLDER = '_app/booking/confirm-after';

/**
 * What the Book press says about the phone yes, beside the booking's own outcome.
 *   recorded    the Confirmed answer applied in the same press
 *   waiting     the booking (or the answer) is still with the processor; the answer follows
 *   refused     the booking applied, the phone yes did not — it shows under Needs your attention
 *   not-booked  the booking was refused: nothing was confirmed
 */
export interface BookConfirmResult {
  state: 'recorded' | 'waiting' | 'refused' | 'not-booked';
  message?: string | null;
}
